import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { pluralize } from "@sellar-io/common";
import { useRemoteFeatureFlags } from "~/hooks/useRemoteFeatureFlags";

export const useCreditTermsText = ({
  connection,
  includePaymentType = true,
}: {
  connection:
    | Pick<
        SupplierRelationshipGetResponseType,
        "paymentTerms" | "paymentDueCalculateFrom" | "paymentDue"
      >
    | null
    | undefined;
  includePaymentType?: boolean;
}) => {
  const isImplicitProformaActive =
    useRemoteFeatureFlags().isActive("implicitProforma");

  let startOfString = includePaymentType
    ? isImplicitProformaActive
      ? "Supplier credit"
      : "Credit"
    : "";
  let middleOfString = "";
  let endOfString = "";
  if (
    (connection?.paymentDueCalculateFrom &&
      connection.paymentDueCalculateFrom !== "invoiceIssueDate") ||
    connection?.paymentDue
  ) {
    startOfString += startOfString ? " : " : "";
  }
  if (connection?.paymentDueCalculateFrom === "endOfFollowingMonth") {
    middleOfString = connection.paymentDue ? "EOFM + " : "EOFM";
  }

  if (connection?.paymentDueCalculateFrom === "endOfMonth") {
    middleOfString = connection.paymentDue ? "EOM + " : "EOM";
  }

  if (connection?.paymentDue) {
    endOfString = `${connection.paymentDue} ${pluralize(
      "day",
      connection.paymentDue,
    )}`;
  }
  return `${startOfString}${middleOfString}${endOfString}`;
};
